import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "sw-dlt19",
  name: `DLT-19 Blaster\n(Denix Conversion)`,
  nameFormatted: {
    primary: "DLT-19 Blaster",
    secondary: "(Denix Conversion)",
  },
  origin: "Star Wars: Episode IV A New Hope",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
